const AbstractEntity = require('@/lib/Entities/AbstractEntity');
const { populate } = require('@/functions/objects');
const { toBool, toFloat, toInt, toIntArray, toNullableInt, toNullableString, toString } = require('@/functions/transform');

class Offer extends AbstractEntity {
    constructor(data = null) {
        super();

        this.applyPerTriggerLimit = null;

        this.code = null;

        /**
         * @type {Number[]}
         */
        this.itemIDs = [];

        /**
         * @type {Number[]}
         */
        this.catIDs = [];

        /**
         * @type {Number[]}
         */
        this.eventIDs = [];

        this.name = '';

        /**
         * @type {bool|null}
         */
        this.requiresSupervisorApproval = null;

        /**
         * Which items this offer can be applied to.
         *
         * @type {string}
         */
        this.target = 'anyItems';

        this.trigger = null;
        this.value = 0.00;

        /**
         * @type {"value"|"percentage"|"variable"}
         */
        this.valueType = undefined;

        /**
         * @type {number}
         */
        this.navOrder = 0;

        if (data) {
            populate(this, data);
        }
    }

    getHydrationMap() {
        return {
            ...super.getHydrationMap(),
            applyPerTriggerLimit: toNullableInt,
            catIDs: toIntArray,
            code: toNullableString,
            eventIDs: toIntArray,
            ID: {
                field: ['ID', 'offerID'],
                transform: toInt,
            },
            itemIDs: toIntArray,
            name: {},
            navOrder: toInt,
            requiresSupervisorApproval: toBool,
            target: toString,
            trigger: {},
            value: toFloat,
            valueType: toString,
        };
    }

    isCouponCodeOffer() {
        return this.trigger === 'coupon';
    }

    isManuallyAppliedToCart() {
        return this.trigger === 'manualOrder';
    }

    isManuallyAppliedToLine() {
        return this.trigger === 'manualLine';
    }

    isVariable() {
        return this.valueType === 'variable';
    }

    /**
     * Check if this offer can be applied to the given item ID.
     *
     * @param {number} itemID
     * @param {number} catID
     * @param {number} eventID
     *
     * @return {boolean}
     */
    supportsItem(itemID, catID, eventID) {
        switch (this.target) {
            case 'anyItems':
                return true;
            case 'selectedItems':
                return this.itemIDs.indexOf(itemID) !== -1;
            case 'anyEvents':
                return !!eventID;
            case 'selectedEvents':
                return this.eventIDs.indexOf(eventID) !== -1;
            case 'selectedCategories':
                return this.catIDs.indexOf(catID) !== -1;
        }

        return false;
    }
}

module.exports = Offer;
